// The candidate's choice of a female or male voice, shared by the AI interviewer and the site guide.

export const VOICE_GENDER_KEY = 'ew_voice_gender';
export const VOICE_GENDER_EVENT = 'ew-voice-gender';
export const VOICE_GENDERS = [
  { id: 'female', label: 'Female voice' },
  { id: 'male', label: 'Male voice' },
];

export const cleanGender = (value) => (value === 'male' ? 'male' : 'female');

export const readVoiceGender = () => {
  try {
    return cleanGender(localStorage.getItem(VOICE_GENDER_KEY));
  } catch {
    return 'female';
  }
};

export const saveVoiceGender = (value) => {
  const gender = cleanGender(value);
  try {
    localStorage.setItem(VOICE_GENDER_KEY, gender);
  } catch {
    /* private mode */
  }
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent(VOICE_GENDER_EVENT, { detail: gender }));
  }
  return gender;
};

// Browsers name their voices rather than tagging a gender, so match common voice names.
const MALE = /\b(male|man|david|mark|james|george|daniel|alex|fred|guy|ryan|thomas|aaron|arthur|oliver|rishi|ravi|prabhat|christopher|eric|roger|steffan)\b/i;
const FEMALE = /\b(female|woman|zira|samantha|susan|hazel|victoria|karen|moira|tessa|fiona|veena|heera|aria|jenny|libby|sonia|natasha|kate|serena|allison|ava|neerja|swara|catherine|emma|michelle|linda)\b/i;

export const pickBrowserVoice = (voices, gender, lang = 'en') => {
  const list = Array.isArray(voices) ? voices : [];
  const local = list.filter((v) => String(v.lang || '').toLowerCase().startsWith(lang));
  const pool = local.length ? local : list;
  const want = cleanGender(gender) === 'male' ? MALE : FEMALE;
  const avoid = cleanGender(gender) === 'male' ? FEMALE : MALE;
  return pool.find((v) => want.test(v.name || '') && !avoid.test(v.name || '')) || null;
};

// Without a matching named voice, shift the default voice's pitch toward the choice.
export const pitchFor = (gender, matchedVoice) => {
  if (matchedVoice) return 1;
  return cleanGender(gender) === 'male' ? 0.75 : 1.2;
};
